import { Injectable, signal } from '@angular/core';
import { ToastType } from '../ui/types/toast-type.type';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  icon = signal('');
  message = signal('');
  type = signal<ToastType>('default');
  isVisible = signal(false);

  constructor() { }

  showToast(icon: string, message: string, type: ToastType) {
    this.icon.set(icon);
    this.message.set(message);
    this.type.set(type);
    this.isVisible.set(true);
    setTimeout(() => this.isVisible.set(false), 4000);
  }
}
